// src/config/DashboardConfig.ts

import { RevenueCardData, ChartData } from './Dashboard';

export const revenueCards: RevenueCardData[] = [
  {
    title: 'Total Revenue Received',
    value: '1,000,000 ₹',
    subText: 'Revenue Overview',
    colorClass: 'bg-blue-500',
    textColorClass: 'text-blue-500',
  },
  {
    title: 'Total Deal Value',
    value: '1,000,000 ₹',
    subText: '', // No subtext on image
    colorClass: 'bg-orange-500',
    textColorClass: 'text-orange-500',
  },
  {
    title: 'Active Deals Revenue (5 Active Deals)',
    value: '3,45,000 ₹',
    subText: '',
    colorClass: 'bg-green-500',
    textColorClass: 'text-green-500',
  },
  {
    title: 'Pending Payments',
    value: '4,00,000 ₹',
    subText: '',
    colorClass: 'bg-red-500',
    textColorClass: 'text-red-500',
  },
];

// Placeholder for Revenue Trends data (Jan - May)
export const revenueTrendsData: ChartData[] = [
  { name: 'Jan', value: 78000 },
  { name: 'Feb', value: 65000 },
  { name: 'Mar', value: 70000 },
  { name: 'Apr', value: 78000 },
  { name: 'May', value: 74000 },
];

// Placeholder for Performance Line data (Jan - Dec)
export const performanceData: ChartData[] = [
  { name: 'Jan', value: 90000 },
  { name: 'Feb', value: 150000 },
  { name: 'Mar', value: 70000 },
  { name: 'Apr', value: 60000 },
  { name: 'May', value: 110000 },
  { name: 'Jun', value: 155000 },
  { name: 'Jul', value: 70000 },
  { name: 'Aug', value: 160000 },
  { name: 'Sep', value: 125000 },
  { name: 'Oct', value: 40000 },
  { name: 'Nov', value: 95000 },
  { name: 'Dec', value: 120000 },
];

export const metricsData = [
  {
    label: "Revenue",
    target: 14,
    achieved: 13,

  },
  {
    label: "Deals",
    target: 14,
    achieved: 14,
  },
  {
    label: "Accounts",
    target: 14,
    achieved: 14,
  },
];

export const performanceTable = [
  {
    metric: "Revenue",
    target: 0,
    achieved: 12000,
  },
  {
    metric: "Deals",
    target: 0,
    achieved: 12000,
  },
  {
    metric: "Account",
    target: 0,
    achieved: 12000,
  },
];